import moment from 'moment';
import Exanimo from './exanimo';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

moment.locale('lv');

window.Exanimo = Exanimo;

try {
    if (window.appJsLoaded) {
        window.appJsLoaded.call(this);
    }
} catch (e) {
    console.error(e);
    Sentry.captureException(e);
}